// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"d3a65c90","234":"023fa4f8","359":"127d0516","361":"f4871ff9"}[chunkId] + ".chunk.js";
};